import type { ViewType } from "../../components/organisms/workItemsTable/types";

export function cloneViewsPreservingFns(views: ViewType[]): ViewType[] {
  return views.map((view) => ({
    ...view,
    columns: (view.columns ?? []).map((col) => ({ ...col })),
  }));
}
